<template>
  <div class="b-doughnut">
    <div class="b-doughnut__chart">
      <doughnutChart
        :labels="chartData.labels"
        :datasets="chartData.datasets"></doughnutChart>
    </div>
    <div class="b-doughnut__legend">
      <ul>
        <li
          v-for="(label, index) in chartData.labels"
          :key="'chart-label-' + index"
          class="b-doughnut__legend__item"
          >
          <div
            class="b-doughnut__legend__color"
            :style="{
              'background-color': chartData.datasets[0].backgroundColor[index],
            }"></div>
          <div class="b-doughnut__legend__value">
            {{ chartData.datasets[0].data[index] }}%
          </div>
          <div class="b-doughnut__legend__name" v-html="label"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import doughnutChart from './doughnut-chart.vue'

export default {
  components: {
    doughnutChart,
  },
  props: {
    chartData: {
      required: true,
      type: Object,
    },
  },
  computed: {},
}
</script>
